/**
 * Get the customer facing manufacturer name from the brand string
 * @param {string} brand
 */
export default function(brand = '') {
    if (brand == 'peugeot') {
        return 'Peugeot';
    }
    if (brand == 'citroen') {
        return 'Citroen';
    }
    if (brand == 'vauxhall') {
        return 'Vauxhall';
    }
    if (brand == 'ds') {
        return 'DS';
    }
    if (brand == 'ds-automobiles') {
        return 'DS';
    }
    if (brand == 'ds automobiles') {
        return 'DS';
    }
    if (brand == 'fiat') {
        return 'Fiat';
    }
    if (brand == 'abarth') {
        return 'Abarth';
    }
    if (brand == 'jeep') {
        return 'Jeep';
    }
    if (brand == 'alfa-romeo') {
        return 'Alfa Romeo';
    }
    if (brand == 'leapmotor') {
        return 'Leapmotor';
    }

    return 'Stellantis &You UK';
}